import { render, staticRenderFns } from "./CartSection.vue?vue&type=template&id=5808f2dd&scoped=true&"
import script from "./CartSection.vue?vue&type=script&lang=js&"
export * from "./CartSection.vue?vue&type=script&lang=js&"
import style0 from "./CartSection.vue?vue&type=style&index=0&id=5808f2dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5808f2dd",
  null
  
)

export default component.exports